import React from 'react';
import services from '../../services';
import { Modal,Space, Button, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Lang from '../../lang'

const { confirm } = Modal;


class ConfirmationModal extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            content : ""
        }
    }

    handleTitle = () => {
      let heading = ''
      if(this.props.useFor === 'User') heading = Lang.langCheck.langRequest('Are you sure?')
      else if(this.props.useFor === 'Group') heading = 'Você tem certeza que deseja apagar?'
      return heading;
    }

    handleContent = () => {
        let content = '' , textName = ''
        if(this.props.useFor === 'User'){
            textName = "O utilizador " + this.props.row.name
            // content = "O utilizador "+ name + " será excluído"
        }else if(this.props.useFor === 'Group'){
          textName =   this.props.row.groupName   
        }
        content = "Está prestes a eliminar " + textName + ". Esta ação resultará na perda de dados, sem a possibilidade de retorno."
        return content
    }

    showConfirmModal = () =>{
        
        const handleConfirmationModal = () => {
            this.props.handleConfirmation(this.props.row)
        }

        confirm({
          title: this.handleTitle(),
          icon: <ExclamationCircleOutlined />,
          content: this.handleContent(),
          okText: this.props.useFor === 'Group' ? "SIM" : Lang.langCheck.langRequest('Yes'),
          okType: 'danger k-button k-primary btn-ivdp-primary',
          cancelText: this.props.useFor === 'Group' ? "NÃO" :Lang.langCheck.langRequest('No'),
          cancelButtonProps: {className : 'k-button k-primary btn-ivdp-secondary'},
          onOk() {
            handleConfirmationModal();
          },
          onCancel() {
            //console.log('Cancel');
          },
        });
      }
    
    render(){
        return (
            <Space>
                <Tooltip title="Excluir" color={"#808080"}>
                  <span onClick={this.showConfirmModal} className="k-icon k-i-delete cursor-pointer text-inactive"></span>
                </Tooltip>
          </Space>
        )
    }
}

export default ConfirmationModal;